<template>
  <div>
    <!--    <img src="@/assets/seats.jpg" alt="background" style=" margin:20px auto; width: 99%">-->
    <p style="margin: 20px">温馨提示：违约系统已上线，违约超过三次将禁止预约三周，违约次数每月1号清零。请大家合理安排时间，如不能及时到场可取消预约。</p>
    <p style="margin: 20px">亲爱的老师、同学们，因寒假期间留校人数少，健身房咖啡屋日常设备也需要阶段性维护，自1月20日起，健身房咖啡屋暂停开放，2月23日起恢复预约。特此公告！祝寒假平安快乐。</p>

    <p style="margin: 20px">
      <span style="color: #67C23A;text-shadow:0 0 1px #67C23A">绿色</span>表示可预约，<span style="color: #E6A23C;text-shadow:0 0 1px #E6A23C">橙色</span>表示已约满。
    </p>



    <p style="margin: 20px;color: #F56C6C;text-shadow:0 0 1px #F56C6C" v-if="!loading&&allFull">
      目前已全部约满。
    </p>
    <span>
        <el-button @click="getGymInfo"
                   style="margin: 5px;display: inline"
                   :loading="loading">
          刷新
        </el-button>
    </span>
    <div v-for="item of periods">
      <el-popover
          placement="top"
          width="320"
          v-model="item.visible">


        <div style="text-align: left; margin: 0">

          <el-popover
              placement="top"
              width="280"
              v-model="item.info.visible">

            <p>确定选择:{{ item.period + " " + parsePeriod(item.period) }} 吗?</p>
            <el-button size="mini" type="primary"
                       @click="item.info.visible=false;doSelect(item.period,item)">确定
            </el-button>
            <el-button size="mini" @click="item.info.visible=false">取消</el-button>


            <div v-loading="item.loading" slot="reference" style="margin: 10px auto">
              <el-tag style="margin: 10px;display: block">
                {{ item.period + " " + parsePeriod(item.period) }}
              </el-tag>
              <el-tag style="margin: 10px;display: block">
                总开放位置数：{{ item.info.totalNum}}
              </el-tag>
              <el-tag style="margin: 10px;display: block" type="warning"
                      v-if="item.info.totalNum<=item.info.selectedNum">
                可用位置数：{{ item.info.totalNum - item.info.selectedNum }}
              </el-tag>
              <el-tag style="margin: 10px;display: block" v-else type="success">
                可用位置数：{{ item.info.totalNum - item.info.selectedNum }}
              </el-tag>
              <el-button type="plain" style="margin-left: 10px">
                选择此时间段
              </el-button>
            </div>
          </el-popover>

          <div style="margin: 5px;color: orange" v-if="item.info.totalNum<=item.info.selectedNum">
            此时间段位置已满
          </div>

          <br>
          <div style="text-align: right">
            <el-button size="mini" type="text" @click="item.loading=true;GetPeriodInfo(item)"
            >刷新座位
            </el-button>
            <el-button size="mini" type="text" @click="item.visible = false;"
            >取消
            </el-button>
          </div>
        </div>

        <el-button slot="reference" @click="item.loading=true;GetPeriodInfo(item)"
                   :loading="item.loading" :type="item.avail?'success':'warning'" style="margin: 5px" plain>
          {{ item.period + " " + parsePeriod(item.period) }}
        </el-button>
      </el-popover>

      <br>
    </div>
    <span style="margin: 5px;color: orange" v-if="periods.length===0">暂无时间段可选择</span>
    <span>
        <el-button @click="getGymInfo"
                   style="margin: 5px;display: inline"
                   :loading="loading">
          刷新
        </el-button>
    </span>

  </div>


</template>

<script>
import axios from '@/utils/request'
import {parsePeriod} from "@/utils/WeekParser";

export default {
  name: 'GymSelect',
  data() {
    return {
      periods: [],
      loading: false,
      allFull: false
    }
  },
  methods: {
    parsePeriod(p) {
      return parsePeriod(p)
    },
    getGymInfo() {
      this.allFull = true
      this.loading = true
      axios.post("/GetGymInfo", {key: this.$store.state.nowRoom.key}).then(res => {
        console.log(res);
        this.loading = false
        let array = []
        for (let item of res.data.data.array) {
          array.push({
            info: {
              visible: false,
              loading: false
            },
            period: item.period,
            avail: item.avail !== 0,
            // avail: false,
            visible: false,
            loading: false
          })
          if (item.avail !== 0) {
            this.allFull = false
          }
        }
        this.periods = array
      })
    },
    GetPeriodInfo(item) {
      item.loading = true
      console.log("period: " + item.period)
      axios.post("/GetGymPeriodInfo", {
        Period: item.period, key: this.$store.state.nowRoom.key
      }).then(res => {
        console.log(res);
        item.loading = false
        item.info = {
          selectedNum: res.data.data.array[0].selectedNum,
          totalNum: res.data.data.array[0].totalNum,
          visible: false,
          loading: false
        }
      })
    },
    doSelect(period, item) {
      axios.post("/DoSelectGym", {Period: period, key: this.$store.state.nowRoom.key}).then(() => {
        this.GetPeriodInfo(item)
      })
    }

  },
  mounted() {

  },
  created() {
    this.getGymInfo()
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
